import script from "./displayJSONRecursive.vue?vue&type=script&setup=true&lang=js"
export * from "./displayJSONRecursive.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__